// ─── Astria Japan Kyusei — shared DOB persistence across the Viral / Timing /
// Companion tabs. Only the fetched result payloads are cached per-tab
// (sessionStorage, see KyuseiJapanForm.tsx); the DOB itself is stored here so
// switching tabs can silently re-fetch without asking the user to type it
// again.

const DOB_STORAGE_KEY = "astriaJapanKyuseiDob";

export const getStoredAstriaJapanDob = (): string | null => {
  try {
    return localStorage.getItem(DOB_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setStoredAstriaJapanDob = (dob: string): void => {
  try {
    localStorage.setItem(DOB_STORAGE_KEY, dob);
  } catch {
    // ignore storage failures (e.g. private browsing quota)
  }
};
